import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  getInvoiceDetailsRoute,
  getInvoiceTableRoute,
  getEarningDisbursedRoute,
  getReminderTimeRoute,
  getParticularsRoute,
  removeInvoicesRoute,
} from '../../utils/apiRoutes';

export const getInvoiceTableAsync = createAsyncThunk(
  `${moduleName}/getInvoiceTable`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getInvoiceTableRoute(),
      params: {
        ...payload,
        // limit: 6,
      },
    });
    // console.log('invoice table res', response.data);
    const data = response.data;
    return data;
  }
);

export const getInvoiceDetailsAsync = createAsyncThunk(
  `${moduleName}/getInvoiceDetails`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getInvoiceDetailsRoute(),
      params: {
        ...payload,
      },
    });
    // console.log('invoice details res', response.data);
    const data = response.data;
    return data;
  }
);

export const getEarningDisbursedAsync = createAsyncThunk(
  `${moduleName}/getEarningDisbursed`,
  async () => {
    const response = await axios({
      method: 'GET',
      url: getEarningDisbursedRoute(),
    });
    const data = response.data;
    return data;
  }
);

export const getReminderTimeAsync = createAsyncThunk(
  `${moduleName}/getReminderTime`,
  async () => {
    const response = await axios({
      method: 'GET',
      url: getReminderTimeRoute(),
    });
    console.log('response.data', response.data);
    const data = response.data;
    return data;
  }
);

export const getParticularsAsync = createAsyncThunk(
  `${moduleName}/getParticulars`,
  async () => {
    const response = await axios({
      method: 'GET',
      url: getParticularsRoute(),
    });
    const data = response.data;
    return data;
  }
);

export const removeInvoiceAsync = createAsyncThunk(
  `${moduleName}/deleteInvoice`,
  async ({ _id }) => {
    console.log('payload delete', _id);
    const response = await axios({
      method: 'PUT',
      url: removeInvoicesRoute(),
      params: {
        _id,
      },
    });
    const data = response.data;
    return data;
  }
);

const transactionInvoicesSlice = createSlice({
  name: `${moduleName}/transactionInvoices`,
  initialState: {
    loading: false,
    transactionInvoicesData: [],
    invoiceTableData: [],
    invoiceTableCount: '',
    invoiceDetails: [],
    earningAndDisbursed: [],
    particulars: [],
    reminderTime: '',
    discount: '',
    referral: '',
    removeInvoice: [],
    error: '',
  },
  reducers: {},
  extraReducers: {
    [getInvoiceTableAsync.pending]: (state) => {
      state.loading = true;
    },
    [getInvoiceTableAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.invoiceTableData = action.payload.data;
      state.invoiceTableCount = action.payload.count;
    },
    [getInvoiceTableAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getInvoiceDetailsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getInvoiceDetailsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.invoiceDetails = action.payload.data;
    },
    [getInvoiceDetailsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getEarningDisbursedAsync.pending]: (state) => {
      state.loading = true;
    },
    [getEarningDisbursedAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.earningAndDisbursed = action.payload.data;
    },
    [getEarningDisbursedAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getReminderTimeAsync.pending]: (state) => {
      state.loading = true;
    },
    [getReminderTimeAsync.fulfilled]: (state, action) => {
      state.loading = false;
      console.log('time -> ', action.payload);
      state.reminderTime = action.payload.time;
      //   state.reminderTime = '2021-10-09T22:30:44.549Z';
      state.discount = action.payload.discount;
      state.referral = action.payload.referral;
    },
    [getReminderTimeAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getParticularsAsync.pending]: (state) => {
      state.loading = true;
    },
    [getParticularsAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.particulars = action.payload.data;
    },
    [getParticularsAsync.rejected]: (state) => {
      state.loading = false;
    },
    [removeInvoiceAsync.pending]: (state) => {
      state.loading = true;
    },
    [removeInvoiceAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.removeInvoice = action.payload;
    },
    [removeInvoiceAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export const { leadDetailsData } = transactionInvoicesSlice.actions;

export default transactionInvoicesSlice.reducer;
